export default "__VITE_ASSET__C_iRkd0b__"